<div class="row">  
  <span class="col-md-12 text-right boldlbl">Page 2 of 10</span>  
</div>
<div class="row p-4">
    <div class="col-md-12">
        <h3 class="text-center">New Business Registration</h3>
        <h4 class="text-center">FastTrack Questionnaire</h4>
    </div>
</div>
<div *ngIf="errorExist" id="alertRef" class="alert alert-danger fadein">
    <a href="#" class="close" data-dismiss="alert">&times;</a> <strong>Error!</strong>
    {{errorMessage}}
</div>
<div class="row">
    <div class="col-md-12 text-right">
        <label class="boldlbl"><span class="errorMsg">*</span>indicates required field.</label>
    </div>
</div>
<form [formGroup]="fForm" (ngSubmit)="submit()">
    <div class="card">
        <div class="card-body">
            <div class="table-condensed table-responsive">                
                    <!-- display new acct verification section  -->
                <table class="table table-borderless">
                    <!-- display new acct verification section  -->
                    <tbody [attr.id]="TRCQGroups[DupEntryGrpRow]?.metaName">
                        <tr>
                            <td colspan="4">
                                <strong>{{TRCQGroups[DupEntryGrpRow].questionGroup}}</strong>
                            </td>
                        </tr>
                        <tr *ngIf="TRCQGroups[DupEntryGrpRow]?.notes">
                            <td colspan="4">
                                {{TRCQGroups[DupEntryGrpRow].notes}}
                            </td>
                        </tr>
                        <jhi-fasttrack-dsp-questions-answers [qQuestions]="qQuestions" [parentForm]="fForm" [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndY" (answerAdded)="update($event)" style="display:contents">
                        </jhi-fasttrack-dsp-questions-answers>
                    </tbody>
                </table> 
                <div style="border: thin solid black; background-color:white">
  				<table class="table">
    				<tbody>
                        <tr>
                            <td width="70%" colspan="2">
                                {{TRCQGroups[FastTrackGrpRow]?.notes}}
                            </td>
                            <td width="30%" colspan="2">
                            <div class="form-check-inline">
                            <label class="form-check-label boldlbl">Yes</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input" name="TRCQGroups[FastTrackGrpRow].questionGroup" value="Y" (change)="isFTYes(TRCQGroups[FastTrackGrpRow],$event)"  />
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">No</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input" name="TRCQGroups[FastTrackGrpRow].questionGroup" value="N"  (change)="isFTYes(TRCQGroups[FastTrackGrpRow],$event)"  /> 
                        </div>
                            </td>

      					</tr>
    			</tbody>
  				</table>
				</div>              
                <table id="level1_table"  class="table table-bordered">                                                                                                                                                      
                    <tbody [attr.id]="TRCQGroups[FastTrackGrpRow]?.metaName">
                         
                        
                        <div><p><br><br><br>Select one of the <b>5</b> options below for your Business Activity:</p></div>  
                                                                        
                        <jhi-fasttrack-dsp-questions-answers [qQuestions]="qQuestions1" [parentForm]="fForm" [DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqIndN" [disabledValue]="isDisabledValue" (answerAdded)="update($event)" (errorBlock)="isBlock($event)" (errorBlock1)="isBlock1($event)" style="display:contents">
                        </jhi-fasttrack-dsp-questions-answers>
                         
                        
                        <!-- include eappreg_get_table here -->
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div>
        <br>
    </div>
    <div class="text-center">
        <input type="button" class="btn btn-primary" routerLink="/eappreg_criteria" value="Back"/>
        <button type="submit" class="btn btn-primary">Accept and Proceed</button>
    </div>
    <div>
        <br>
    </div>
</form>